<epay-page-content [pagetitle]="pagetitle">
  <div class="box-panel shadow max-w max-gs">
    <div class="m--pa4">
      <h2 class="mb-5">Contact Us</h2>
      <h3>Telephone</h3>
      1-877-279-4730 <br>
      <br>
    </div>
  </div>
</epay-page-content>
